import { CARD_READER_PAYMENT_METHOD } from "src/main/Billing/Payments/helpers"

const UNCHOSEN_METHOD = "unchosen"
export const SAVED_METHOD = "saved"
export const CARD_READER_METHOD = "reader"
export const OFFLINE_METHOD = "offline"

export const OFFLINE_TENDERS = [
  { paymentType: "cash", copyKey: "cash" },
  { paymentType: "check", copyKey: "check", field: "checkNumber" },
  { paymentType: "manual_ach", copyKey: "manualAch", field: "achConfirmation" },
  { paymentType: "external_txn", copyKey: "externalTxn", field: "notes" },
]

export const MANUAL_PAYMENT_METHOD = "manual"

export const PAYMENT_PAID = "paid"
export const PAYMENT_PROCESSING = "processing"

export const selectedMethod = ({
  paymentMethodId,
  paymentType,
  cardReaderId,
}) => {
  if (!paymentMethodId) {
    return { kind: UNCHOSEN_METHOD }
  }
  if (paymentMethodId === MANUAL_PAYMENT_METHOD) {
    return { kind: OFFLINE_METHOD, id: paymentType }
  }
  if (paymentMethodId === CARD_READER_PAYMENT_METHOD) {
    return { kind: CARD_READER_METHOD, id: String(cardReaderId) }
  }
  return { kind: SAVED_METHOD, id: String(paymentMethodId) }
}

export const findTender = (paymentType) =>
  OFFLINE_TENDERS.find((tender) => tender.paymentType === paymentType)

export const buildTxn = ({ method, values, cardReaderId }) => {
  if (method.kind === OFFLINE_METHOD) {
    const tender = findTender(method.id)
    const offlinePaymentAttributes = { paymentType: tender.paymentType }
    if (tender.field) {
      offlinePaymentAttributes[tender.field] = values[tender.field]
    }
    return { type: "Billing::OfflinePaymentTxn", offlinePaymentAttributes }
  }

  return {
    type: "Billing::StripePaymentTxn",
    stripePaymentAttributes:
      method.kind === CARD_READER_METHOD
        ? { cardReaderId }
        : { paymentMethodId: Number(method.id) },
  }
}

export const trackedMethod = ({ method, paymentMethods }) => {
  if (method.kind === OFFLINE_METHOD) {
    return method.id
  }
  if (method.kind === CARD_READER_METHOD) {
    return "card_reader"
  }
  const paymentMethod = paymentMethods.find(
    ({ id }) => String(id) === method.id
  )
  return paymentMethod?.type === "PaymentMethod::BankAccount"
    ? "bank_account"
    : "card"
}
